// Google Analytics integration

var GoogleAnalytics = function() {
  this._gaTracker = undefined;
};

GoogleAnalytics.prototype.init = function() {
  // Set GA tracker
  this._setGaTracker();

  // Register elements
  this._registerElements();
};

// Checks for GA repeatedly until it's available. It may not
// be available immediately since it's loaded via GTM.
GoogleAnalytics.prototype._setGaTracker = function() {
  var interval;

  var trackerSetter = function() {
    // Check if GA loaded yet
    if (typeof ga !== 'function' || typeof ga.getAll !== 'function') return;

    // Get and set tracker
    this._gaTracker = ga.getAll()[0];

    // Clear interval
    clearInterval(interval);
  };

  interval = setInterval(trackerSetter.bind(this), 250);
};

GoogleAnalytics.prototype._registerElements = function() {
  var register = function(index, element) {
    var $element = $(element);

    // Setup click handler
    $element.on('click', this._handleClick.bind(this));
  };

  // Register each GA event-element
  $('[data-ga-category]').each(register.bind(this));
};

GoogleAnalytics.prototype._handleClick = function(e) {
  var $target = $(e.currentTarget);

  // Get event info from element
  var category = $target.data('ga-category');
  var action = $target.data('ga-action');
  var label = $target.data('ga-label');

  // Build GA event object
  var eventObj = {
    hitType: 'event',
    eventCategory: category,
    eventAction: action,
    eventLabel: label
  };

  // Send event
  if (this._gaTracker && eventObj) {
    console.info('Google Analytics', eventObj);
    this._gaTracker.send(eventObj);
  }
};

// Boot
(new GoogleAnalytics()).init();